module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/street-43.ea0921f3.png";